/**
 * Created by andrey on 08.08.2025
 */

cc.RotateTo = function (duration, deltaAngleX, deltaAngleY) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._dstAngleX = 0;
    this._startAngleX = 0;
    this._diffAngleX = 0;

    this._dstAngleY = 0;
    this._startAngleY = 0;
    this._diffAngleY = 0;

    if (deltaAngleX !== undefined) {
        this.initWithDuration(duration, deltaAngleX, deltaAngleY);
    }
};

cc.RotateTo.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.RotateTo,

    initWithDuration: function (duration, deltaAngleX, deltaAngleY) {
        if (cc.ActionInterval.prototype.initWithDuration.call(this, duration)) {
            this._dstAngleX = deltaAngleX || 0;
            this._dstAngleY = deltaAngleY !== undefined ? deltaAngleY : this._dstAngleX;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);

        // Calculate X
        const locStartAngleX = target.rotationX % 360.0;
        let locDiffAngleX = this._dstAngleX - locStartAngleX;
        if (locDiffAngleX > 180) {
            locDiffAngleX -= 360;
        }
        if (locDiffAngleX < -180) {
            locDiffAngleX += 360;
        }
        this._startAngleX = locStartAngleX;
        this._diffAngleX = locDiffAngleX;

        // Calculate Y  It's duplicated from calculating X since the rotation wrap should be the same
        this._startAngleY = target.rotationY % 360.0;
        let locDiffAngleY = this._dstAngleY - this._startAngleY;
        if (locDiffAngleY > 180) {
            locDiffAngleY -= 360;
        }
        if (locDiffAngleY < -180) {
            locDiffAngleY += 360;
        }
        this._diffAngleY = locDiffAngleY;
    },

    update: function (dt) {
        dt = this._computeEaseTime(dt);
        if (this.target) {
            this.target.rotationX = this._startAngleX + this._diffAngleX * dt;
            this.target.rotationY = this._startAngleY + this._diffAngleY * dt;
        }
    }
});

cc.rotateTo = (duration, deltaAngleX, deltaAngleY) => new cc.RotateTo(duration, deltaAngleX, deltaAngleY);
